// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JnTJ","title":"Header_title__1O1qP","side":"Header_side__3ucQa"};